import { B2CHalfCardConfig } from "@payment-ui/interfaces/BillToCompany";
import { isEmpty } from "@swiggy-private/js-utils";

export const isB2CHalfCardConfigValid = (b2CHalfCardConfig?: B2CHalfCardConfig): boolean => {
    return !isEmpty(b2CHalfCardConfig) && !isEmpty(b2CHalfCardConfig?.fields);
};